import { fetchEventPage, type EventPage } from './fetchEventPage'

/**
 * Query params for a schedule's event list.
 *
 * The same filters `/events/membership` takes, minus `schedule_id` — the
 * schedule is the path here, not a filter. The competition schedule sends the
 * same values to its games request, so the two lists stay bounded alike.
 *
 * Every field is optional: an absent key means "no filter", which is not the
 * same as sending an empty one.
 */
export interface ListScheduleEventsQuery {
  team_id?: string
  organization_id?: string
  venue_id?: string
  facility_id?: string
  /** Include events on the schedule's descendants (its divisions). */
  recursive?: number
  starts_after?: string
  starts_before?: string
  order?: string
  per_page?: number
  sport_id?: string
  generic_sport_id?: string
  /** Free-text search. */
  query?: string
}

/**
 * ONE page of the events on a schedule — a competition, season or division.
 *
 * This endpoint REPLACED `/events/membership` for the competition schedule
 * list. That one answers for the events the CURRENT USER has a membership claim
 * on, so anyone browsing a competition they are not rostered in — a league
 * admin most of all — saw an empty list where events plainly existed. This one
 * is scoped by the schedule itself, so it answers the question the page asks.
 *
 * `/events/membership` remains in use for the viewer's own schedule, where
 * membership scoping is the point.
 *
 * Errors throw, like every other event service.
 */
export const listScheduleEventsPage = (
  scheduleId: string,
  query: ListScheduleEventsQuery = {},
  page = 1
): Promise<EventPage> =>
  fetchEventPage(`/schedules/${scheduleId}/events`, query, page)
